import { render, staticRenderFns } from "./metadata-file.vue?vue&type=template&id=6f65758a&scoped=true&"
import script from "./metadata-file.vue?vue&type=script&lang=js&"
export * from "./metadata-file.vue?vue&type=script&lang=js&"
import style0 from "./metadata-file.vue?vue&type=style&index=0&id=6f65758a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f65758a",
  null
  
)

export default component.exports